export const FilterDataTabIds = {
    COUNTRIES: 1,
    CATEGORIES: 2,
    SUPPLIERS: 3,
    BRANDS: 4,
    ATTRIBUTE_TYPES: 5,
    ATTRIBUTES: 6,
    RETAILER_TYPES: 7,
    RETAILERS: 8,
    DATE_RANGE_PRICE_SKU_SIZE: 9,
    PROMOTIONS: 10,
};
